import _ from 'lodash';
import constants from '$$helpers/constants';
import timeParser from '$$helpers/timeParser';
import timeTrackingModel from '$$timeTrackingModel';
import getSumOfLogsForParent from './getSumOfLogsForParent';
import icon_timer from '../../svg/footerToolbar/timer.svg';

export default function (ganttTask) {
  if (ganttTask.type === constants.TASK_TYPES.button) {
    return '';
  }

  const taskLogs = timeTrackingModel.getLogsByParamsNotCopy(ganttTask.gantt_id, ganttTask.id);
  let value = taskLogs?.sum || 0;
  let sumForParent = 0;

  if (ganttTask.type === constants.TASK_TYPES.project) {
    sumForParent = getSumOfLogsForParent(ganttTask.id, ganttTask.gantt_id);
  }

  const userActivity = _.find(user.activity, o => o.name === 'timeTracker');
  let trackerData = null;

  if (userActivity) {
    trackerData = JSON.parse(userActivity.settings);
  }

  if (trackerData && trackerData.task_id === ganttTask.id) {
    return icon_timer;
  }

  if (!ganttTask.parent) {
    value = sumForParent;
  }

  return sumForParent + value;
}
